import { createEventHook } from '@retailer-platform/shared-components/src/hooks/event-hooks/createEventHook'

export type UnauthorizedRequestEventTypes = {
  partnerWriteAccessError: {
    partnerNames: string[]
    partnerIds: number[]
  }
}

export const [emitUnauthorizedRequest, useOnUnauthorizedRequest] =
  createEventHook<UnauthorizedRequestEventTypes>()
